import { Stack } from '@mui/material'

import { Button } from '@/components/ContentStack/Button'
import { Link } from '@/components/ContentStack/Link'
import { MediaList } from '@/components/ContentStack/MediaList'
import { SimpleText } from '@/components/ContentStack/SimpleText'
import { RichText } from '@/components/RichText'

import type { ReactElement } from 'react'
import type { StackOwnProps } from '@mui/material'
import type { ContentStack as Content } from '@/gen/sanity/schema'

interface ContentStackProps extends StackOwnProps {
  content?: Content
  linkIcon?: ReactElement
}

export const ContentStack: React.FC<ContentStackProps> = ({ content, sx, linkIcon, ...stackProps }) => {
  return (
    <Stack spacing={2} sx={{ textAlign: 'left', ...sx }} {...stackProps}>
      {content?.items?.map((item) => {
        if (item._type === 'button') {
          return <Button key={item._key} {...item} />
        }
        if (item._type === 'link') {
          return (
            <Stack key={item._key} direction="row" {...stackProps}>
              {linkIcon}
              <Link key={item._key} {...item} />
            </Stack>
          )
        }
        if (item._type === 'simpleText') {
          return <SimpleText key={item._key} {...item} />
        }
        if (item._type === 'richText') {
          return <RichText key={item._key} {...item} linkIcon={linkIcon} />
        }
        if (item._type === 'mediaList') {
          return <MediaList key={item._key} {...item} {...stackProps} />
        }
        if (item._type === 'contentStack') {
          return <ContentStack key={item._key} content={item} linkIcon={linkIcon} {...stackProps} />
        }
      })}
    </Stack>
  )
}
